import { render, staticRenderFns } from "./change_state_star_page.vue?vue&type=template&id=032c7abc&scoped=true"
import script from "./change_state_star_page.vue?vue&type=script&lang=js"
export * from "./change_state_star_page.vue?vue&type=script&lang=js"
import style0 from "./change_state_star_page.vue?vue&type=style&index=0&id=032c7abc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c7abc",
  null
  
)

export default component.exports